import { WsSelect, WsSelectObj } from 'wisestep-base';

import WsFilterProps from '../models/WsFilterProps';

import WsAccordion from './WsAccordion';
const options: WsSelectObj[] = [
  {
    label: 'All',
    value: 'All',
  },
  {
    label: 'Posted',
    value: 'Posted',
  },
  {
    label: 'Assigned',
    value: 'Assigned',
  },
  {
    label: 'Unassigned',
    value: 'Unassigned',
  },
  {
    label: 'Not Assigned',
    value: 'NotAssigned',
  },
];

const StatusFilter = ({ name }: WsFilterProps) => (
  <WsAccordion title="Job Status">
    <WsSelect name={name} label="Status" selectArray={options} />
  </WsAccordion>
);

export default StatusFilter;
